import {month, ordinal, setPropertyPx} from "./library";
import {PureComponent} from "react";
import {fitImageToFigure, selectImage} from "./imageSizing";

// returns true if the image is taller than the figure,  otherwise returns false

class MainFrame extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            imageURL: false,
            dimensions: {
                "titleHeight": 85,
                "bottomHeight": 110,
            }
        };
    }

    componentDidMount = async () => {
        this.props.registerAdapt(this.adaptToSize)
    }

    componentWillUnmount = () => {
        this.props.registerAdapt(undefined)
    }

    adaptToSize = ({navWidth, articleWidth}) => {
        const { config , pathname } = this.props
        const { images } = config
        const { dimensions } = this.state
        const { titleHeight, bottomHeight } = dimensions

        setPropertyPx('--titleHeight', titleHeight)
        setPropertyPx('--bottomHeight', bottomHeight)

        const figureHeight = window.innerHeight - titleHeight - bottomHeight
        setPropertyPx('--imgHeight', figureHeight)
        const imgSize = [images[0].width, images[0].height]
        const [fitX, fitY] = fitImageToFigure(imgSize, [articleWidth, figureHeight])
        const scaledX = fitX * window.devicePixelRatio
        const scaledY = fitY * window.devicePixelRatio
        const selectedImage = selectImage(images, scaledX, scaledY)
        this.setState({
            isReady: true,
            imageURL: pathname + selectedImage.name
        })
    }

    render = () => {
        const {imageURL} = this.state
        const { config } = this.props
        const {date_taken, subtitle, copyright_type,
            photographer, contact, title} = config

        const [yyyy, mm, dd] = date_taken.split("-").map(x => parseInt(x))

        return <article className={"MainFrame"}>
                <div className={"heading"}><h1>{title}</h1></div>
                <div className={"figure"}>{imageURL ? <img src={imageURL} alt={title}/> : undefined}</div>
                <div className={"footer"}>
                    <div>{month(mm)} {dd}<sup>{ordinal(dd)}</sup> {yyyy}</div>
                    <div>{subtitle}</div>
                    <div>&copy; {yyyy} {copyright_type} by {photographer}; contact {contact}</div>
                </div>
            </article>;
    }

    static page_title = "Photograph"
}

export default MainFrame;
